import React, { useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import NewsletterForm from "../../components/NewsletterForm";
import { useStoryblok } from "../../lib/storyblok";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { StoryProvider, getStaticProps } from "../[...slug]";

export default function Subscribe({ story: storyProp, ...props }) {
  const story = useStoryblok(storyProp, true);
  const [signUpError, setSignUpError] = useState(false);
  const router = useRouter();

  return (
    <StoryProvider {...props} story={story}>
      <Header />
      <div className="Grid Subscribe">
        <div className="Grid-block Grid-block--large Subscribe-wrapper">
          <div className="Subscribe-heading">
            {/* Sign up to our newsletter */}
            ニュースレターに登録する
          </div>
          <NewsletterForm
            placeholder="メールアドレスを入力してください"
            // Enter your email
            signUpError={() => setSignUpError(true)}
            routeToConfirmationPage={() => {
              router.push("subscribe/confirmation");
            }}
          />
          {signUpError && (
            <div className="Subscribe-error">
              {/* Something went wrong. Please make sure to type a valid email
              address. */}
              エラーが発生しました。有効なメールアドレスを入力してください。
            </div>
          )}
        </div>
        <div className="Grid-block Grid-block--large">
          <Image
            src="/img/SGcdPa.jpg"
            alt="Subscribe - Monokel"
            layout="fill"
          />
        </div>
      </div>
      <Footer />
    </StoryProvider>
  );
}

export { getStaticProps };
